import { DEFAULT_VIDEO_SIZE_TYPE } from '@anm/constants/embed';
import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import {
  changeEmbedType,
  saveEmbedStatusAsync,
  toggleEmbedStatus,
  updateEmbedSizes
} from '../actions';
import { HostedVideoActions } from '../types';

import { updateEmbedSizeType, updatePopoverEmbed } from './../actions';
import { initialHostedVideoState } from './index';

const embedVideoReducer: Reducer<
  typeof initialHostedVideoState,
  HostedVideoActions
> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(toggleEmbedStatus): {
      const newStatus = action.payload;

      return {
        ...state,
        embedVideo: {
          ...state.embedVideo,
          status: newStatus
        }
      };
    }

    case getType(changeEmbedType): {
      const embedType = action.payload;

      return {
        ...state,
        embedVideo: {
          ...state.embedVideo,
          data: {
            ...state.embedVideo.data!,
            type: embedType,
            sizeType: DEFAULT_VIDEO_SIZE_TYPE
          }
        }
      };
    }

    case getType(updateEmbedSizes): {
      const sizes = action.payload;

      return {
        ...state,
        embedVideo: {
          ...state.embedVideo,
          data: {
            ...state.embedVideo.data!,
            sizes
          }
        }
      };
    }

    case getType(updateEmbedSizeType): {
      const sizeType = action.payload;

      return {
        ...state,
        embedVideo: {
          ...state.embedVideo,
          data: {
            ...state.embedVideo.data!,
            sizeType
          }
        }
      };
    }

    case getType(updatePopoverEmbed): {
      const popover = action.payload;

      return {
        ...state,
        embedVideo: {
          ...state.embedVideo,
          data: {
            ...state.embedVideo.data!,
            popover: {
              ...state.embedVideo.data?.popover!,
              ...popover
            }
          }
        }
      };
    }

    case getType(saveEmbedStatusAsync.request): {
      return {
        ...state,
        saveEmbedStatus: {
          isError: false,
          isPending: true
        }
      };
    }
    case getType(saveEmbedStatusAsync.success): {
      return {
        ...state,
        saveEmbedStatus: {
          error: null,
          isError: false,
          isPending: false
        }
      };
    }
    case getType(saveEmbedStatusAsync.failure): {
      const { payload: newError } = action;
      return {
        ...state,
        saveEmbedStatus: {
          error: newError,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default embedVideoReducer;
